function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  margin-top: auto;\n  padding: 0; /* 구분선이 전체 너비를 차지하도록 패딩 제거 */\n  border-top: none;\n  position: relative; // Added for dropdown positioning context\n  \n  /* 내부 컨텐츠에 패딩을 적용하기 위해 직접 자식 요소에 패딩 추가 */\n  > * {\n    padding: 0.75rem; /* 상하좌우 동일한 패딩 */\n  }\n\n  @media (max-width: 768px) {\n    border-top: none;\n    margin-top: 0;\n  }\n  \n  &.vscode-profile-preview {\n    border-top-color: var(--vscode-panel-border, #e5e7eb);\n  }\n  \n  &.tablet-view {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    \n    > * {\n      padding: 0; /* 태블릿에서는 패딩 제거 - 중앙 정렬을 방해하지 않도록 */\n    }\n    \n    /* 태블릿 뷰에서 내부 relative div도 중앙 정렬 */\n    > div {\n      display: flex;\n      justify-content: center;\n      align-items: center;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  border-radius: 9999px; // rounded-full\n  border: none;\n  background: none;\n  cursor: pointer;\n  overflow: hidden;\n  transition: all 0.2s;\n  \n  &:hover {\n    /* transform: scale(1.05); 제거 - 사이드바 스크롤바 문제 해결 */\n    box-shadow: 0 0 0 2px var(--color-primary, #3b82f6); // Use theme color if available\n    opacity: 0.9; /* 시각적 피드백을 위한 대체 효과 */\n  }\n  \n  &:focus {\n    outline: none;\n    box-shadow: 0 0 0 2px var(--color-primary, #3b82f6);\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  padding: 0.5rem 1rem; // px-4 py-2\n  border-bottom: 1px solid var(--theme-border-light, ",
        "); // border-b border-gray-200 dark:border-gray-700\n\n  .user-name { // Class for styling name\n    font-weight: 500; // font-medium\n    font-size: 0.875rem; // text-sm\n    line-height: 1.25rem;\n    color: var(--theme-text, ",
        "); \n  }\n\n  .user-username { // Class for styling username\n    font-size: 0.75rem; // text-xs\n    line-height: 1rem;\n    color: var(--theme-text-secondary, ",
        "); // text-gray-500 dark:text-gray-400\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex; // flex\n  align-items: center; // items-center\n  padding: 0.75rem; // p-3\n  border-radius: 0.75rem; // rounded-xl\n  width: 100%; // w-full\n  background-color: transparent;\n  border: none;\n  cursor: pointer;\n  transition: background-color 0.15s ease; // transition-colors\n  text-align: left;\n\n  &:hover {\n    background-color: var(--theme-paper-hover, ",
        "); // hover:bg-gray-100 dark:hover:bg-gray-800\n  }\n  \n  // Ensure AuthorDisplay takes up available space\n  > div:first-of-type { // Targeting AuthorDisplay assuming it's the first div\n      flex: 1; // flex-1\n      min-width: 0; // min-w-0\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  margin-left: auto; // ml-auto\n  color: var(--theme-text-muted, ",
        "); // text-gray-400\n  flex-shrink: 0; // Prevent shrinking\n\n  svg {\n    width: 1.25rem; // h-5 w-5\n    height: 1.25rem;\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import styled from '@emotion/styled';
// 기존 스타일드 컴포넌트 정의 이동
export var ProfilePreviewContainer = styled.div(_templateObject());
export var TabletProfileButton = styled.button(_templateObject1());
// 새로 추가된 스타일드 컴포넌트 정의
export var DropdownUserInfo = styled.div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.borderLight;
}, function(param) {
    var theme = param.theme;
    return theme.text;
}, function(param) {
    var theme = param.theme;
    return theme.textSecondary;
});
export var DesktopButtonWrapper = styled.button(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.paperHover;
});
export var ChevronIcon = styled.div(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.textMuted;
});
